import {
  Badge,
  Box,
  Button,
  Card,
  Flex,
  Group,
  Modal,
  ScrollArea,
  Text,
  TextInput,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconMapPinHeart } from "@tabler/icons-react";
import QueryString from "qs";
import { useState } from "react";
import useSWR from "swr";
import Empty from "@/components/placeholders/Empty";
import useAuthStore from "@/store/useAuthStore";
import { parsePhone } from "@/utils/helpers";

export default function PartnerSelectModal({ type, companyId, style, form }) {
  const [opened, { open, close }] = useDisclosure();
  const [name, setName] = useState("");
  const user = useAuthStore((state) => state.user);
  const CL = useAuthStore((state) => state.companyList);

  const params = QueryString.stringify({
    filters: {
      company: companyId,
    },
    pagination: {
      page: 1,
      pageSize: 1000,
    },
    sort: "name:desc",
  });

  const { data, isLoading } = useSWR(opened ? ["/partners", params] : null);

  const c =
    user?.permission === "admin" || user?.permission === "partner"
      ? CL.find((x) => x.id === form.values.company)?.attributes
      : user?.company;

  const companyItem = {
    name: c?.name,
    address: c?.address,
    managerPhoneNumber: c?.phoneNumber,
    lat: c?.lat,
    lng: c?.lng,
  };

  function handleSelect(item) {
    let managerInfo = item.managerPhoneNumber;
    if (item.managerName) managerInfo += `(${item.managerName})`;

    if (type === "load") {
      form.setValues({
        startName: item.name,
        startAddress: item.address,
        startAddressDetail: item.addressDetail,
        startPhoneNumber: managerInfo,
        startLat: item.lat,
        startLng: item.lng,
        isLoadPartner: true,
      });
    }

    if (type === "unload") {
      form.setValues({
        endName: item.name,
        endAddress: item.address,
        endAddressDetail: item.addressDetail,
        endPhoneNumber: managerInfo,
        endLat: item.lat,
        endLng: item.lng,
        isUnloadPartner: true,
      });
    }

    close();
  }

  function handleClose() {
    setName("");
    close();
  }

  return (
    <>
      <Button onClick={open} style={style} leftIcon={<IconMapPinHeart size={18} />}>
        거래처 목록
      </Button>

      <Modal.Root opened={opened} onClose={handleClose} centered size="md">
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header sx={{ borderBottom: "1px solid lightgray" }}>
            <Box w="100%">
              <Group>
                <Modal.Title>거래처 목록</Modal.Title>
                <Modal.CloseButton />
              </Group>

              <TextInput
                mt="sm"
                mb={0}
                placeholder="거래처명 검색"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Box>
          </Modal.Header>
          <Modal.Body px={0}>
            <ScrollArea mih={500} px="sm">
              <Card
                shadow="0"
                p="xs"
                mt="sm"
                sx={{ cursor: "pointer" }}
                bg="gray.0"
                onClick={() => handleSelect(companyItem)}
              >
                <Flex gap="xs">
                  <Badge mt={2} variant="light">
                    내 회사
                  </Badge>
                  <Text fw={700}>{companyItem.name}</Text>
                </Flex>
              </Card>

              {!isLoading && data?.data?.length === 0 && (
                <Empty
                  title="등록된 거래처가 없습니다."
                  text="거래처 관리에서 거래처를 추가해주세요."
                />
              )}

              {data?.data
                ?.filter((x) => (name ? x?.attributes?.name.includes(name) : true))
                ?.map((row) => {
                  const item = row?.attributes || {};
                  return (
                    <Card
                      shadow="0"
                      key={row.id}
                      p="xs"
                      mt="sm"
                      sx={{ cursor: "pointer" }}
                      bg="gray.0"
                      onClick={() => handleSelect(item)}
                    >
                      <Text fw={700}>{item.name}</Text>
                      <Text size="sm" mt={2}>
                        {item.address}
                      </Text>
                      <Text size="sm" mt={2}>
                        {parsePhone(item.managerPhoneNumber)} · {item.managerName}
                      </Text>
                    </Card>
                  );
                })}
            </ScrollArea>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
}
